/**
 * API tablero asignación auxiliar ↔ clientes fiscales.
 */
import api from "@/lib/api";
import { DESPACHO_ASSIGNMENTS_FORBIDDEN_MESSAGE } from "@/modules/despacho/despachoPermissions";
import { parseDespachoAssignmentsError } from "@/modules/despacho/despachoAssignmentsApi";

export const FISCAL_ASSIGNMENT_BOARD_PATH = "/despacho/fiscal-assignment-board";

export const FORBIDDEN_FISCAL_BOARD_MESSAGE =
  "No tienes habilitado Gestión Despacho para ver asignaciones.";

export const EMPTY_FISCAL_BOARD_MESSAGE =
  "Aún no hay empresas en el catálogo fiscal. Regístrelas en Clientes para asignar auxiliares.";

export const LOAD_FISCAL_BOARD_ERROR = "No pudimos cargar el tablero de asignaciones.";

export function parseFiscalAssignmentBoardError(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;

  if (status === 403) {
    const code = typeof detail === "object" && detail?.code;
    if (code === "DESPACHO_ASSIGNMENTS_FORBIDDEN") {
      return { kind: "assignments_forbidden", message: DESPACHO_ASSIGNMENTS_FORBIDDEN_MESSAGE };
    }
    if (code === "MODULE_NOT_LICENSED" || code === "LICENSE_BLOCKED") {
      return { kind: "forbidden", message: FORBIDDEN_FISCAL_BOARD_MESSAGE };
    }
    return { kind: "forbidden", message: FORBIDDEN_FISCAL_BOARD_MESSAGE };
  }

  if (status === 404) {
    return { kind: "not_found", message: "Cliente fiscal no encontrado." };
  }

  return { kind: "error", message: LOAD_FISCAL_BOARD_ERROR };
}

export function createFiscalAssignmentBoardApi(httpClient = api) {
  return {
    async listBoard() {
      const { data } = await httpClient.get(FISCAL_ASSIGNMENT_BOARD_PATH);
      return Array.isArray(data?.items) ? data.items : [];
    },

    async replaceAssignments(fiscalClientId, assignments) {
      const { data } = await httpClient.put(
        `/despacho/fiscal-clients/${fiscalClientId}/assignments`,
        { assignments },
      );
      return data;
    },

    async bulkAssignments({ staffUserId, fiscalClientIds, action }) {
      const { data } = await httpClient.post(`${FISCAL_ASSIGNMENT_BOARD_PATH}/bulk`, {
        staff_user_id: staffUserId,
        fiscal_client_ids: fiscalClientIds,
        action,
      });
      return data;
    },

    async exportBoard({ format = "csv", view = "todas", staffUserId = "", q = "" } = {}) {
      const params = { format, view };
      if (staffUserId) params.staff_user_id = staffUserId;
      if (q) params.q = q;
      const response = await httpClient.get(`${FISCAL_ASSIGNMENT_BOARD_PATH}/export`, {
        params,
        responseType: "blob",
      });
      const blob = response.data;
      const disposition = response.headers?.["content-disposition"] || "";
      const match = disposition.match(/filename="([^"]+)"/);
      const filename = match?.[1] || `asignacion_fiscal.${format === "pdf" ? "pdf" : "csv"}`;
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    },
  };
}

export const fiscalAssignmentBoardApi = createFiscalAssignmentBoardApi();

export function parseFiscalAssignmentSaveError(err) {
  return parseDespachoAssignmentsError(err);
}
